import * as React from "react";

import {
  StatusBadge as StatusBadgePrimitive,
  StatusBadgeLook,
} from "@/shared/foundation/primitives";

import { type StatusBadgeSpec } from "./statusBadges";

export interface StatusBadgeProps {
  /** An entry of `STATUS_BADGES`, e.g. `STATUS_BADGES.invocation[status]`. */
  status: StatusBadgeSpec;
  /** Replaces the status's own label; rare. */
  label?: string;
  /** Detail shown on hover: a time, an error, what the status means. */
  tooltip?: React.ReactNode;
  /** Makes the badge a button. */
  onClick?: () => void;
  /** The badge's accessible name, where the label alone would not say enough. Defaults to the label. */
  "aria-label"?: string;
  /** Set on the badge's outer element: the button, or the span around the pill. */
  "data-testid"?: string;
}

/** A status from the registry, drawn as the shared status pill. */
export const StatusBadge = React.forwardRef<HTMLElement, StatusBadgeProps>(
  function StatusBadge({ status, label, ...rest }, ref) {
    return (
      <StatusBadgePrimitive
        {...rest}
        ref={ref}
        tone={status.tone}
        icon={status.icon}
        label={label ?? status.label}
      />
    );
  },
);

/** Just the pill for a registry status, inside a trigger of the caller's own. */
export function StatusBadgePill({
  status,
  label,
}: {
  status: StatusBadgeSpec;
  label?: string;
}) {
  return (
    <StatusBadgeLook
      tone={status.tone}
      icon={status.icon}
      label={label ?? status.label}
    />
  );
}
